import React, { useMemo } from "react";

import { GetMenuItemsAvailableFilters } from "@/api/requests/getMenuItems";
import { CATEGORY_NAMES } from "@/constants/dispensary";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { coinListDataFactory } from "@/utils/coinListDataFactory";
import { dispensaryHref } from "@/utils/dispensaryUrls";
import { nestedFilterValuesByName } from "@/utils/filterUtils";

import CoinList from "@/components/CoinList";

const CategoryCarousel: React.FC<{
  className?: string;
  dispensaryRetailType?: string;
  dispensarySlug: string;
  availableFilters: GetMenuItemsAvailableFilters;
}> = ({
  className,
  dispensarySlug,
  dispensaryRetailType,
  availableFilters,
}) => {
  const countryCode = useDomainCountryCode();

  const hrefLink = dispensaryHref({
    additionalPath: "/menu",
    countryCode,
    retailType: dispensaryRetailType,
    slug: dispensarySlug,
  });

  const selectCategories = useMemo(() => {
    const categories =
      nestedFilterValuesByName(availableFilters, "product_category") || [];

    const popularCategories = Object.keys(CATEGORY_NAMES).reduce(
      (list: string[], categoryName) => {
        const matchingCategory = categories?.find(
          (name) => categoryName === name,
        );
        return matchingCategory ? [...list, matchingCategory] : list;
      },
      [],
    );

    const otherCategories =
      categories?.filter(
        (name) => !Object.keys(CATEGORY_NAMES).includes(name),
      ) || [];

    return [...popularCategories, ...otherCategories];
  }, [JSON.stringify(availableFilters)]);
  const coinCategories = Object.keys(CATEGORY_NAMES).filter((category) =>
    selectCategories.includes(category),
  );

  const coinListData = coinListDataFactory.createCoinListDataForCategories(
    coinCategories,
    CATEGORY_NAMES,
  );

  return (
    <CoinList
      className={className}
      coinData={coinListData}
      hrefLink={hrefLink}
      hrefProductCatQueryKey="product_category[]"
      isLoading={false}
      title="Shop by category"
    />
  );
};

export default CategoryCarousel;
